<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, 0.9); margin-top: 200px">
      <div class="message" v-if="!isRegistrationFormVisible">
        Możliwość zgłaszania gabinetu została wyłączona.
      </div>

      <v-form
        v-if="isRegistrationFormVisible"
        ref="form"
        id="needs-validation"
        v-model="valid"
        lazy-validation
        class="pt-3"
      >
        <v-container class="site-padding">
          <v-layout align-center justify-center row wrap class="register-form">
            <v-flex xs12 class="text-xs-left">
              <h1 class="register-form--header">formularz rejestracyjny</h1>
              <div class="sparator-container pt-4">
                <div class="sparator-rectangle"></div>
              </div>
              <span
                >Przed przystąpieniem do akcji prosimy o&nbsp;zapoznanie sie
                z</span
              >
              <router-link
                :to="{ name: 'Regulations' }"
                class="register-form--links"
                >regulaminem.</router-link
              >
              <div>
                <span class="register-form--sections">uwaga!</span>
                <span
                  >Prosimy o&nbsp;zadeklarowanie godzin bezpłatnych przyjęć
                  pacjentów w&nbsp;ramach akcji Polscy Okuliści Kontra
                  Jaskra.</span
                >
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container class="site-bottom-padding">
          <v-layout row wrap>
            <v-flex xs12 md6 lg4 class="mb-3">
              <v-layout>
                <v-flex xs4 md12 class="text-xs-left">
                  <div class="register-container--download">
                    <v-avatar :size="60" color="rgb(39, 82, 113)">
                      <img
                        src="/static/images/human-icon.svg"
                        alt=""
                        style="height: 60%; border-radius: 0"
                      />
                    </v-avatar>
                    <div class="register-container--download-text">
                      <span class="register-container--sections"
                        >dane zgłaszającego</span
                      >
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container class="site-padding">
          <v-layout align-center justify-center row wrap class="register-form">
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Imię"
                solo
                v-model="declarant.first_name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Nazwisko"
                solo
                v-model="declarant.last_name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="E-mail"
                solo
                v-model="declarant.email"
                :rules="emailRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Telefon"
                solo
                v-model="declarant.phone"
                mask="###########"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-bottom-padding">
          <v-layout row wrap>
            <v-flex xs12 md6 lg4 class="mb-3">
              <v-layout>
                <v-flex xs4 md12 class="text-xs-left">
                  <div class="register-container--download">
                    <v-avatar :size="60" color="rgb(39, 82, 113)">
                      <img
                        src="/static/images/home-icon.svg"
                        alt=""
                        style="height: 50%; border-radius: 0"
                      />
                    </v-avatar>
                    <div class="register-container--download-text">
                      <span class="register-container--sections"
                        >dane placówki</span
                      >
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-padding">
          <v-layout
            align-center
            justify-center
            row
            wrap
            class="register-form mx-1"
          >
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Nazwa placówki"
                solo
                v-model="institution.name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-select
                :items="items"
                label="Województwo"
                solo
                v-model="institution.state"
                :rules="nameRules"
              ></v-select>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Ulica i numer"
                solo
                v-model="institution.address"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Miejscowość"
                solo
                v-model="institution.city"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Kod pocztowy"
                solo
                v-model="institution.post_code"
                :rules="postcodeRules"
                mask="##-###"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Deklarowana liczba pacjentów"
                solo
                v-model="institution.patients_number"
                :rules="patientRules"
                mask="###"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Telefon placówki"
                solo
                v-model="institution.institution_phone"
                mask="###########"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-text-field
                label="Dodatkowy telefon"
                solo
                v-model="institution.institution_phone2"
                mask="###########"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-bottom-padding">
          <v-layout row wrap>
            <v-flex xs12 class="mb-3">
              <v-layout>
                <v-flex xs12 class="text-xs-left">
                  <div class="register-container--download">
                    <v-avatar :size="60" color="rgb(39, 82, 113)">
                      <img
                        src="/static/images/clock-icon.svg"
                        alt=""
                        style="height: 50%; border-radius: 0"
                      />
                    </v-avatar>
                    <div class="register-container--download-text">
                      <span class="register-container--sections"
                        >godziny bezpłatnych przyjęć pacjentów w&nbsp;ramach
                        akcji polscy okuliści kontra jaskra 2024</span
                      >
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-padding">
          <v-layout
            align-center
            justify-center
            row
            wrap
            class="register-form mx-1"
          >
            <v-flex
              xs8
              md4
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Niedziela</span>
                  <span>- {{ this.parseDate(this.sunday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day1_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day1.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day1_start_menu"
                    v-model="availibility.day1.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day1.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day1_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Poniedziałek</span>
                  <span>- {{ this.parseDate(this.monday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day2_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day2.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day2_start_menu"
                    v-model="availibility.day2.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day2.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day2_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Wtorek</span>
                  <span>- {{ this.parseDate(this.tuesday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day3_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day3.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day3_start_menu"
                    v-model="availibility.day3.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day3.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day3_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Środa</span>
                  <span>- {{ this.parseDate(this.wednesday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day4_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day4.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day4_start_menu"
                    v-model="availibility.day4.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day4.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day4_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Czwartek</span>
                  <span>- {{ this.parseDate(this.thursday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day5_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day5.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day5_start_menu"
                    v-model="availibility.day5.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day5.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day5_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Piątek</span>
                  <span>- {{ this.parseDate(this.friday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day6_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day6.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day6_start_menu"
                    v-model="availibility.day6.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day6.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day6_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="time-container">
                <div class="time-container--separator">
                  <span class="register-form--sections">Sobota</span>
                  <span>- {{ this.parseDate(this.saturday) }}</span>
                </div>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="day7_start_menu"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="availibility.day7.start_at"
                    label="OD"
                    mask="time"
                    return-masked-value
                    solo
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    color="rgb(164, 22, 17)"
                    format="24hr"
                    v-if="day7_start_menu"
                    v-model="availibility.day7.start_at"
                    full-width
                    @change="$refs.menu.save(time)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="availibility.day7.start_at = ''"
                      >USUŃ</v-btn
                    >
                    <v-btn
                      flat
                      color="rgb(164, 22, 17)"
                      @click="day7_start_menu = false"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </div>
            </v-flex>
            <v-flex
              xs4
              md2
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
            >
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day1_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day1.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day1_end_menu"
                  v-model="availibility.day1.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day1.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day1_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day2_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day2.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day2_end_menu"
                  v-model="availibility.day2.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day2.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day2_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day3_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day3.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day3_end_menu"
                  v-model="availibility.day3.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day3.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day3_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day4_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day4.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day4_end_menu"
                  v-model="availibility.day4.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day4.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day4_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day5_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day5.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day5_end_menu"
                  v-model="availibility.day5.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day5.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day5_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day6_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day6.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day6_end_menu"
                  v-model="availibility.day6.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day6.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day6_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="day7_end_menu"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="availibility.day7.finish_at"
                  label="DO"
                  mask="time"
                  return-masked-value
                  solo
                  readonly
                ></v-text-field>
                <v-time-picker
                  color="rgb(164, 22, 17)"
                  format="24hr"
                  v-if="day7_end_menu"
                  v-model="availibility.day7.finish_at"
                  full-width
                  @change="$refs.menu.save(time)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="availibility.day7.finish_at = ''"
                    >USUŃ</v-btn
                  >
                  <v-btn
                    flat
                    color="rgb(164, 22, 17)"
                    @click="day7_end_menu = false"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0">
              <v-textarea
                class="register-form--noShadow register-form--spacing"
                label="Uwagi"
                solo
                full-width
                height="502"
                rows="27"
                no-resize
                v-model="declarant.comment"
              ></v-textarea>
            </v-flex>
            <v-flex
              xs12
              class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-4 pr-1 term-container"
            >
              <div class="two-column">
                <div class="single-col">
                  <div class="styled-input-container styled-input--rounded">
                    <div class="styled-input-single">
                      <input
                        type="checkbox"
                        v-model="declarant.accepted"
                        v-validate="'required'"
                        data-vv-name="declarant.accepted"
                        data-vv-as="zgody"
                        name="declarant.accepted"
                        id="checkbox3-example-one"
                      />
                      <label for="checkbox3-example-one"
                        >Wyrażam zgodę na przetwarzanie przez firmę Compass
                        Public Relations s.c. K. Waligóra, A. Pawlikowska z
                        siedzibą w Warszawie przy ul. Chłodnej 64 lok. 223, kod:
                        00-872 moich danych osobowych zawartych
                        w&nbsp;formularzu rejestracyjnym w&nbsp;celu
                        i&nbsp;zakresie niezbędnym do rejestracji na wydarzenie
                        organizowane przez Compass Public Relations s.c. K.
                        Waligóra, A. Pawlikowska. <br /><br />W związku
                        z&nbsp;wejściem nowego rozporządzenia Unii Europejskiej
                        o&nbsp;ochronie danych osobowych tzw. RODO wyrażam zgodę
                        na przetwarzanie moich danych osobowych zawartych
                        w&nbsp;niniejszym zgłoszeniu dla potrzeb niezbędnych do
                        informowania o&nbsp;Konferencjach i&nbsp;Zjazdach
                        organizowanych przez firmę Compass Public Relations s.c.
                        K. Waligóra, A. Pawlikowska z siedzibą w Warszawie przy
                        ul. Chłodnej 64 lok. 223, kod: 00-872 (zgodnie
                        z&nbsp;Rozporządzeniem Parlamentu Europejskiego
                        i&nbsp;Rady (UE) 2016/679 - RODO/GDPR z&nbsp;dnia 27
                        kwietnia 2016 roku, ustawy o&nbsp;ochronie danych
                        osobowych z&nbsp;dnia 10 maja 2018&nbsp;r.).</label
                      >
                      <div class="v-messages__wrapper error--text">
                        <i
                          v-show="errors.has('declarant.accepted')"
                          class="fa fa-warning"
                        ></i>
                        <span
                          v-show="errors.has('declarant.accepted')"
                          class="v-messages__message v-messages"
                          >{{ errors.first("declarant.accepted") }}</span
                        >
                      </div>
                    </div>
                    <div class="styled-input-single">
                      <input
                        type="checkbox"
                        v-model="declarant.accepted2"
                        name="declarant.accepted2"
                        id="checkbox3-example-two"
                      />
                      <label for="checkbox3-example-two"
                        >Wyrażam zgodę na przesyłanie mi informacji handlowych
                        środkami komunikacji elektronicznej przez: Polskie
                        Towarzystwo Okulistyczne z&nbsp;siedzibą
                        w&nbsp;Warszawie oraz podmioty współpracujące
                        w&nbsp;szczególności z&nbsp;firmą Compass Public
                        Relations s.c. K. Waligóra, A. Pawlikowska z siedzibą w
                        Warszawie przy ul. Chłodnej 64 lok. 223, kod: 00-87,
                        zgodnie z&nbsp;ustawą z&nbsp;dnia 18 lipca 2002&nbsp;r.
                        o&nbsp;świadczeniu usług drogą elektroniczną
                        (Dz.&nbsp;U. z&nbsp;2002&nbsp;r. Nr&nbsp;144, poz. 1204
                        z&nbsp;późn. zm.). Wyrażam zgodę na przetwarzanie moich
                        danych osobowych przez Polskie Towarzystwo Okulistyczne
                        z&nbsp;siedzibą w&nbsp;Warszawie w&nbsp;celach
                        marketingowych oraz na przekazywanie mi propozycji
                        zawarcia umowy przy użyciu telefonu zgodnie
                        z&nbsp;Ustawą z&nbsp;dnia 16&nbsp;lipca 2004&nbsp;r.
                        Prawo telekomunikacyjne (tj. Dz.&nbsp;U.
                        z&nbsp;2014&nbsp;r. poz. 243).<br />
                        Oświadczam, że zostałam(em) poinformowana(y)
                        o&nbsp;prawie wglądu do moich danych i&nbsp;dokonywaniu
                        ich zmian.</label
                      >
                    </div>
                    <div class="styled-input-single">
                      <input
                        type="checkbox"
                        v-model="declarant.accepted3"
                        v-validate="'required'"
                        data-vv-name="declarant.accepted3"
                        data-vv-as="zgody"
                        name="declarant.accepted3"
                        id="checkbox3-example-three"
                      />
                      <label for="checkbox3-example-three"
                        >Akceptuję
                        <router-link
                          :to="{ name: 'Regulations' }"
                          class="register-form--links"
                          >regulamin.</router-link
                        ></label
                      >
                      <div class="v-messages__wrapper error--text">
                        <i
                          v-show="errors.has('declarant.accepted3')"
                          class="fa fa-warning"
                        ></i>
                        <span
                          v-show="errors.has('declarant.accepted3')"
                          class="v-messages__message v-messages"
                          >{{ errors.first("declarant.accepted3") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container>
          <v-layout row class="mb-3" @click="submit">
            <v-flex class="xs12 sm6">
              <my-button
                title="Zarejestruj"
                text="<span>Zarejestruj</span>"
                customClass="doctor rect-x1"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-container class="site-padding" v-if="isReady()">
        <v-layout row wrap class="mt-2">
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex xs10>
                <div class="register-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <img
                      src="/static/images/Krok1.svg"
                      alt=""
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="register-container--download-text">
                    <span class="register-container--sections">WYPEŁNIJ</span>
                    <span class="ban2">formularz</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex xs10>
                <div class="register-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <img
                      src="/static/images/Krok2.svg"
                      alt=""
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="register-container--download-text">
                    <span class="register-container--sections">WYDRUKUJ</span>
                    <span class="ban2">potwierdzenie otrzymane na e-mail</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex xs10>
                <div class="register-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <img
                      src="/static/images/Krok3.svg"
                      alt=""
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="register-container--download-text">
                    <span class="register-container--sections"
                      >ODEŚLIJ SKAN</span
                    >
                    <span class="ban2"
                      >dokumentów opatrzony pieczątką gabinetu</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex xs10>
                <div class="register-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <img
                      src="/static/images/Krok4.svg"
                      alt=""
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="register-container--download-text">
                    <span
                      class="register-container--sections"
                      style="color: rgb(164, 22, 17)"
                      >ODBIERZ</span
                    >
                    <span class="ban2">materiały informacyjne</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3 class="register-form--links">
              Dziękujemy za rejestację placówki.
            </h3>
            <h4>Proszę sprawdzić email.</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog2" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>
              Godzina rozpoczęcia przyjęć pacjentów musi być wcześniejsza niż
              godzina zakończenia.
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog2 = false"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog4" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>
              Godziny w danym dniu ({{ this.parseDate(error_date) }}) są takie
              same lub krótsze niż pół godziny.
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog4 = false"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog3" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>
              Należy uzupełniać godziny przyjęć parami, czyli po wpisaniu
              godziny rozpoczęcia w&nbsp;danym dniu należy wpisać godzinę
              zakończenia.
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog3 = false"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog5" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>Proszę podać przynajmniej 1 dzień przyjęć w tygodniu!</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog5 = false"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="header-separator" style="height: 50px"></div>
  </div>
</template>

<script>
import MyButton from "@/components/partials/Button";
import DoctorHeader from "@/components/partials/DoctorHeader";
import moment from "moment";

export default {
  data() {
    return {
      hideRegistrationFormDate: "2026-03-09 15:10:00",
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      error_date: null,
      counter: 0,
      time: "",
      day1_start_menu: false,
      day1_start_modal: false,
      day1_end_menu: false,
      day1_end_modal: false,
      day2_start_menu: false,
      day2_start_modal: false,
      day2_end_menu: false,
      day2_end_modal: false,
      day3_start_menu: false,
      day3_start_modal: false,
      day3_end_menu: false,
      day3_end_modal: false,
      day4_start_menu: false,
      day4_start_modal: false,
      day4_end_menu: false,
      day4_end_modal: false,
      day5_start_menu: false,
      day5_start_modal: false,
      day5_end_menu: false,
      day5_end_modal: false,
      day6_start_menu: false,
      day6_start_modal: false,
      day6_end_menu: false,
      day6_end_modal: false,
      day7_start_menu: false,
      day7_start_modal: false,
      day7_end_menu: false,
      day7_end_modal: false,
      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
      sunday: "",
      valid: true,
      items: [
        "dolnośląskie",
        "kujawsko-pomorskie",
        "lubelskie",
        "lubuskie",
        "łódzkie",
        "małopolskie",
        "mazowieckie",
        "opolskie",
        "podkarpackie",
        "podlaskie",
        "pomorskie",
        "śląskie",
        "świętokrzyskie",
        "warmińsko-mazurskie",
        "wielkopolskie",
        "zachodniopomorskie",
      ],
      declarant: [],
      institution: [],
      nameRules: [(v) => !!v || "Pole jest wymagane"],
      postcodeRules: [
        (v) => !!v || "Pole jest wymagane",
        (v) =>
          /^[0-9]{2}[0-9]{3}/.test(v) || "Niepoprawny format kodu pocztowego!",
      ],
      emailRules: [
        (v) => !!v || "E-mail jest wymagany",
        (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            v
          ) || "Zły format",
      ],
      patientRules: [
        (v) => !!v || "Pole jest wymagane",
        (v) => this.isNumber(v) || "Zły format wpisz liczby",
      ],
      availibility: {
        day1: {
          day: "Niedziela",
          id_start_at: "start_day1",
          id_finish_at: "finish_day1",
          start_at: "",
          finish_at: "",
          model: "day1",
        },
        day2: {
          day: "Poniedziałek",
          id_start_at: "start_day2",
          id_finish_at: "finish_day2",
          start_at: "",
          finish_at: "",
          model: "day2",
        },
        day3: {
          day: "Wtorek",
          id_start_at: "start_day3",
          id_finish_at: "finish_day3",
          start_at: "",
          finish_at: "",
          model: "day3",
        },
        day4: {
          day: "Środa",
          id_start_at: "start_day4",
          id_finish_at: "finish_day4",
          start_at: "",
          finish_at: "",
          model: "day4",
        },
        day5: {
          day: "Czwartek",
          id_start_at: "start_day5",
          id_finish_at: "finish_day5",
          start_at: "",
          finish_at: "",
          model: "day5",
        },
        day6: {
          day: "Piątek",
          id_start_at: "start_day6",
          id_finish_at: "finish_day6",
          start_at: "",
          finish_at: "",
          model: "day6",
        },
        day7: {
          day: "Sobota",
          id_start_at: "start_day7",
          id_finish_at: "finish_day7",
          start_at: "",
          finish_at: "",
          model: "day7",
        },
      },
    };
  },
  components: {
    DoctorHeader,
    MyButton,
    moment,
  },
  mounted() {
    this.fetchDate();
  },
  computed: {
    isRegistrationFormVisible() {
      return moment().isBefore(this.hideRegistrationFormDate);
    },
  },
  methods: {
    fetchDate() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/sendDate`,
      }).then((result) => {
        this.monday = result.data.monday;
        this.tuesday = result.data.tuesday;
        this.wednesday = result.data.wednesday;
        this.thursday = result.data.thursday;
        this.friday = result.data.friday;
        this.saturday = result.data.saturday;
        this.sunday = result.data.sunday;
      });
    },
    isNumber(value) {
      if (value === null) {
        return true;
      }
      return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value);
    },
    clearForm() {
      this.declarant.first_name = "";
      this.declarant.last_name = "";
      this.declarant.phone = "";
      this.declarant.email = "";
      this.declarant.comment = "";

      this.institution.name = "";
      this.institution.post_code = "";
      this.institution.city = "";
      this.institution.institution_phone = "";
      this.institution.institution_phone2 = "";
      this.institution.address = "";
      this.institution.patients_number = "";
      this.institution.state = null;
      this.declarant.accepted = "";
      this.declarant.accepted2 = "";
      this.declarant.accepted3 = "";

      Object.keys(this.availibility).map((key) => {
        this.availibility[key].start_at = "";
        this.availibility[key].finish_at = "";
      });
    },
    parseDate(str) {
      let result = new Date(str);
      let month = result.getMonth() + 1;

      return (
        result.getDate() +
        "." +
        (month < 10 ? +0 : null) +
        month +
        "." +
        result.getFullYear()
      );
      return result;
    },
    registrationClosed() {
      const showDate = "2021-03-01 00:00:00";
      if (moment().isBefore(showDate)) {
        return true;
      }
      return false;
    },
    isReady() {
      const showDate = "2020-01-09 00:00:00";
      if (moment().isAfter(showDate)) {
        return true;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        const data = {
          declarant: {
            first_name: this.declarant.first_name,
            last_name: this.declarant.last_name,
            email: this.declarant.email,
            phone: this.declarant.phone,
            comment: this.declarant.comment,
            accepted: this.declarant.accepted,
            accepted2: this.declarant.accepted2,
            accepted3: this.declarant.accepted3,
          },
          institution: {
            name: this.institution.name,
            address: this.institution.address,
            city: this.institution.city,
            state: this.institution.state,
            post_code: this.institution.post_code,
            phone: this.institution.institution_phone,
            phone2: this.institution.institution_phone2,
            patients_number: this.institution.patients_number,
          },
          availabilities: [
            {
              date: this.sunday,
              start_at: this.availibility.day1.start_at,
              end_at: this.availibility.day1.finish_at,
            },
            {
              date: this.monday,
              start_at: this.availibility.day2.start_at,
              end_at: this.availibility.day2.finish_at,
            },
            {
              date: this.tuesday,
              start_at: this.availibility.day3.start_at,
              end_at: this.availibility.day3.finish_at,
            },
            {
              date: this.wednesday,
              start_at: this.availibility.day4.start_at,
              end_at: this.availibility.day4.finish_at,
            },
            {
              date: this.thursday,
              start_at: this.availibility.day5.start_at,
              end_at: this.availibility.day5.finish_at,
            },
            {
              date: this.friday,
              start_at: this.availibility.day6.start_at,
              end_at: this.availibility.day6.finish_at,
            },
            {
              date: this.saturday,
              start_at: this.availibility.day7.start_at,
              end_at: this.availibility.day7.finish_at,
            },
          ],
        };
        for (let i = 0; i < data.availabilities.length; i++) {
          const start = moment(data.availabilities[i].start_at, "HH:mm");
          const end = moment(data.availabilities[i].end_at, "HH:mm");
          if (
            data.availabilities[i].start_at !== "" &&
            data.availabilities[i].end_at !== "" &&
            start.isAfter(end)
          ) {
            this.dialog2 = true;
            return;
          }

          if (
            data.availabilities[i].start_at &&
            !data.availabilities[i].end_at
          ) {
            this.dialog3 = true;
            return;
          }
          if (
            data.availabilities[i].end_at &&
            !data.availabilities[i].start_at
          ) {
            this.dialog3 = true;
            return;
          }
          if (
            (data.availabilities[i].start_at !== "" &&
              data.availabilities[i].end_at !== "" &&
              data.availabilities[i].end_at ===
                data.availabilities[i].start_at) ||
            end.diff(start, "minutes") < 30
          ) {
            this.dialog4 = true;
            this.error_date = data.availabilities[i].date;
            return;
          }
        }

        for (let i = 0; i < data.availabilities.length; i++) {
          if (data.availabilities[i].end_at !== "") {
            this.counter = this.counter + 1;
          }
        }

        if (this.counter == 0) {
          this.dialog5 = true;
          return;
        }

        if (!this.$validator.validateAll()) {
          return;
        }

        if (!this.declarant.accepted || !this.declarant.accepted3) {
          return;
        }

        this.clearForm();
        this.$refs.form.reset();
        window.scrollTo(0, 0);

        this.axios({
          method: "POST",
          url: `${process.env.APP_URL}/api/registrations`,
          data,
        }).then(
          (response) => {
            this.isDisabled = false;
            this.clearForm();
            this.$refs.form.reset();

            this.dialog = true;
            window.scrollTo(0, 0);
          },
          (response) => {
            this.isDisabled = false;
            Object.keys(response.response.data.errors).map((key) =>
              response.response.data.errors[key].map((error) =>
                this.showErrors(error)
              )
            );
          }
        );
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.term-container--position {
  align-items: baseline !important;
}

.message {
  background: #ab2929;
  color: white;
  font-weight: bold;
  width: 100%;
  text-align: center;

  /* height: 50px; */
  padding: 60px 0;
  /* margin-left: 30px; */
  margin: 60px 0;
  font-size: 1.8rem;
}
.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}
.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}
.banner {
  background-color: transparent;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: "Fira Sans", sans-serif;
  text-align: left;
  color: #aaa;
  display: block;
  vertical-align: middle;
}
.banner img {
  float: left;
}

.time-container {
  display: inline-flex;
  width: 100%;
}
.time-container--separator {
  width: 200px;
  padding-right: 5px;
}
.register-form--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}
.register-form--header {
  font-size: 26px;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  color: #a41611;
  text-transform: uppercase;
}
.register-form--links {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
}
.register-form--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
  word-break: break-word;
}
.register-form--sections-brown {
  color: #a41611;
}
.register-form--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.register-form--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: none;
  padding: 5px;
}
.register-form--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: fixed;
  opacity: 0.1;
  background-image: url("./../assets/images/register-bg.png");
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
}
.button-container--register {
  font-family: "Fira Sans", sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.doctor-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px;
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}

.register-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.register-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}

.register-container--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue